<template>
  <div
    :class="{ 'flex-row-reverse': isReceiver }"
    class="d-flex ma-4"
    style="gap: 8px"
  >
    <SoAvatar ref="so-msg-avatar" :type="isReceiver ? 'soenergy' : undefined" />
    <div>
      <p
        :class="{ 'text-end': isReceiver }"
        class="text-caption text-medium-emphasis"
      >
        {{ date?.toUTCString() }}<br v-if="date" />
        {{ name }}
      </p>
      <v-card
        variant="outlined"
        :class="isPrivate ? 'bg-highlight' : 'bg-white'"
        class="pt-3 rounded"
      >
        <h4 v-if="subject" class="px-4 pb-1">
          {{ `Subject: ${subject}` }}
        </h4>
        <p
          v-if="hasToEmails || from || subject"
          class="text-caption text-medium-emphasis text-black px-4"
        >
          <template v-if="hasToEmails">
            {{ `To: ${to.join(", ")}` }}<br />
          </template>
          {{ from && `From: ${from}` }}
          <v-divider class="mt-1" />
        </p>
        <v-card-text v-html="html" />

        <div
          v-if="$slots.attachments"
          class="ma-4"
          data-testid="so-message-attachments"
        >
          <div class="d-flex flex-wrap gap-1">
            <slot name="attachments"></slot>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoAvatar from "./SoAvatar.vue"

  export default defineComponent({
    components: { SoAvatar },
    inheritAttrs: false,
    props: {
      isReceiver: {
        type: Boolean,
        default: false,
      },
      isPrivate: {
        type: Boolean,
        default: false,
      },
      name: {
        type: String,
        default: null,
      },
      date: {
        type: Date,
        default: null,
      },
      subject: {
        type: String,
        default: null,
      },
      to: {
        type: Array as PropType<string[]>,
        default: () => [],
      },
      from: {
        type: String,
        default: null,
      },
      html: {
        type: String,
        default: null,
      },
    },
    computed: {
      hasToEmails() {
        return this.to.length && this.to.every((str) => str)
      },
    },
  })
</script>
